import { render, staticRenderFns } from "./add-artefact-modal.vue?vue&type=template&id=d03bcbf6&scoped=true&"
import script from "./add-artefact-modal.vue?vue&type=script&lang=ts&"
export * from "./add-artefact-modal.vue?vue&type=script&lang=ts&"
import style0 from "./add-artefact-modal.vue?vue&type=style&index=0&id=d03bcbf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03bcbf6",
  null
  
)

export default component.exports